<template>
  <div class="do-action">
    <div class="header">
      <span class="title">执行动作</span>
      <div class="info">定义被其它系统连接的能力，例如提供接口来提供系统的数据或者消费其它系统推送过来的数据</div>
      <el-button type="primary" icon="el-icon-plus" @click="createAction()">创建执行动作</el-button>
    </div>
    <new-table ref="table" :data="actionData" :columns="columns" :pages="pages" />
  </div>
</template>
<script>
import NewTable from "@/components/new-table.vue";
import ConnectorApis from "@/apis/connector";
import { Clipboard } from "@/utils/util";
export default {
  name: "do-action",
  props: {},
  mounted() {
    this.getActionList();
  },
  data() {
    return {
      actionData: [],
      columns: [
        {
          label: "名称",
          render: (h, { row }) => {
            return (
              <span class="Action-name" onClick={() => this.createAction(row.id)}>
                {row.actionName}
              </span>
            );
          },
        },
        {
          label: "操作",
          width: "200px",
          render: (h, { row }) => {
            return (
              <span>
                <el-button type="text" onClick={() => this.createAction(row.id)}>
                  查看详情
                </el-button>
                <el-button type="text" onClick={() => Clipboard(row.id)}>
                  复制ID
                </el-button>
                <el-button type="text" onClick={() => this.delAction(row.id)}>
                  删除
                </el-button>
              </span>
            );
          },
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.pageChange(p);
          },
        },
      },
      connectorId: this.$route.query.id,
    };
  },
  methods: {
    getActionList() {
      const { currentPage, pageSize } = this.pages.props;
      ConnectorApis.getActionEventList(this.connectorId, currentPage, pageSize).then((res) => {
        this.actionData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    createAction(id) {
      let url = `./create-action?connectorId=${this.connectorId}`;
      if (id) url += `&id=${id}`;
      this.$router.push(url);
    },
    async delAction(id) {
      await this.$confirm("确定要删除这个触发事件吗？", {
        type: "warning",
      });
      await ConnectorApis.deleActionEvent(id);
      this.$message.success("删除成功！");
      this.getActionList();
    },
  },
  components: { NewTable },
};
</script>
<style scoped lang="scss">
.do-action {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  .title {
    margin-right: 12px;
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
  }
  .info {
    flex: 1;
    font-size: 14px;
    line-height: 32px;
    margin-right: 12px;
    color: rgba(0, 0, 0, 0.45);
  }
}
::v-deep {
  .action-name {
    &:hover {
      cursor: pointer;
      color: #3d9cfc;
      text-decoration: underline;
    }
  }
}
</style>
